module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_green_sm-319cd14ba50a2c9374d04b3c90268a52.png";